import {
  LotterySchema,
  RetailUnitSchema,
  WinnerEmailTranslationSchema,
  ClaimMyPrizeTranslationSchema,
  SwipeTranslationSchema,
  SimpleSignupTranslationSchema,
  LegalTranslationSchema,
} from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type GetTranslationsParams = Static<typeof GetTranslationsParamsSchema>;
export const GetTranslationsParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
    lotteryId: LotterySchema.properties.id,
  },
  { additionalProperties: false, $id: 'GetTranslationsParamsSchema' }
);

export type GetTranslationsResponse = Static<typeof GetTranslationsResponseSchema>;
export const GetTranslationsResponseSchema = Type.Object(
  {
    translations: Type.Record(
      Type.String(),
      Type.Object({
        email: Type.Optional(WinnerEmailTranslationSchema),
        claimMyPrize: Type.Optional(ClaimMyPrizeTranslationSchema),
        swipe: Type.Optional(SwipeTranslationSchema),
        simpleSignup: Type.Optional(SimpleSignupTranslationSchema),
        legal: Type.Optional(LegalTranslationSchema),
      })
    ),
  },
  { additionalProperties: false, $id: 'GetTranslationsResponseSchema' }
);
